import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  section: (bg: string, marginTop: number, marginBottom: number) => ({
    background: bg || theme.rawColors.beige300,
    position: 'relative',
    zIndex: theme.zIndex.documentUp,
    width: '100%',
    padding: [`${marginTop}px 40px ${marginBottom}px`, `${marginTop}px 40px ${marginBottom}px`, `${marginTop}px 24px ${marginBottom}px`, `${marginTop}px 24px ${marginBottom}px`, `${marginTop}px 40px ${marginBottom}px`],
    ...theme.grids.mainGrid,
    '.livechat_button-contact': {
      color: theme.rawColors.neutralBlack,
      display: 'block',
      gridColumn: ['span 5', 'span 5', 'span 6', 'span 6', '2 / span 10'],
      border: `1px solid ${theme.rawColors.lightGrey700}`,
      padding: ['16px 14px 16px 14px', '16px 14px 16px 14px', '14px 14px 16px 14px'],
      mt: ['20px', '20px', '40px', '72px'],
      ...reusables.mainTransition('color, border-color, background-color'),
      '&:hover': {
        backgroundColor: theme.rawColors.darkGrey700,
        borderColor: theme.rawColors.darkGrey700,
        color: `${theme.rawColors.neutralWhite}`,
        'h4, p': {
          color: `${theme.rawColors.neutralWhite}`
        },
        path: {
          fill: `${theme.rawColors.neutralWhite}`
        }
      },
      'h4, p, path': {
        ...reusables.mainTransition('color', theme.transitions.animation.atomCurve, theme.transitions.time.fast)
      },
      p: {
        textAlign: 'center'
      },
      'h4.headings.heading__four': {
        fontFamily: theme.fonts.uniform,
        fontSize: [theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h3],
        mb: 0
      },
      '.message': {
        mt: 0
      },
      '.chat_heading': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        span: {
          ml: '16px'
        },
        svg: {
          width: 40,
          height: 40
        }
      }
    }
  }),
  content: {
    color: theme.rawColors.neutralBlack,
    display: 'block',
    gridColumn: ['span 5', 'span 5', 'span 6', 'span 6', '2 / span 10'],
    border: `1px solid ${theme.rawColors.lightGrey700}`,
    padding: ['16px 14px 16px 14px', '16px 14px 16px 14px', '14px 14px 16px 14px'],
    ...reusables.mainTransition('color, border-color, background-color'),
    '&:hover': {
      backgroundColor: theme.rawColors.darkGrey700,
      borderColor: theme.rawColors.darkGrey700,
      color: `${theme.rawColors.neutralWhite}`,
      'h4, p': {
        color: `${theme.rawColors.neutralWhite}`
      },
      path: {
        fill: `${theme.rawColors.neutralWhite}`
      }
    },
    'h4, p, path': {
      ...reusables.mainTransition('color', theme.transitions.animation.atomCurve, theme.transitions.time.fast)
    }
  },
  heading: {
    width: '100%',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'center'
  },
  headingIcon: {
    ml: '16px'
  },
  message: {
    mt: ['8px', '8px', '14px', '14px', 0]
  },
  messageText: {
    textAlign: 'center'
  }
};